<template>
    <BreadCrumb PageTitle="Liste des coupons" />
    <ListeCoupon/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
    import ListeCoupon from "../../../components/Ecommerce/Coupon/ListeCoupon.vue";

    export default defineComponent({
      name: "ListeCouponPage",
      components: {
        BreadCrumb,
        ListeCoupon,
      },
    });
  </script>